module.exports = __webpack_public_path__ + "media/images/icons/rooms/bed-2p-1d69b747854c57d45f677bd677a63b2e.svg";